export const GET_PROJECTS = 'sagas/project/GET_PROJECTS';
export const GET_PROJECT = 'sagas/project/GET_PROJECT';
export const CREATE_PROJECT = 'sagas/project/CREATE_PROJECT';
export const FILL_PROJECT_TASK = 'sagas/project/FILL_PROJECT_TASK';
export const ADD_PROJECT_CAUSE = 'sagas/project/ADD_PROJECT_CAUSE';
export const GET_PROJECT_CAUSES = 'sagas/project/GET_PROJECT_CAUSES';
